import { jwtDecode } from "jwt-decode";
import dayjs from 'dayjs';
import axios from "axios";

const baseURL = import.meta.env.VITE_API_URL;

const getAuthTokens = () => {
  const storedLoginInfo = localStorage.getItem("Login_info");
  if (!storedLoginInfo) return null;

  try {
    return JSON.parse(storedLoginInfo) as { token: string; refreshToken: string };
  } catch (error) {
    console.error("Error parsing Login_info:", error);
    return null;
  }
};



let authTokens = getAuthTokens();

const axiosInstance = axios.create({
  baseURL,
  headers: { Authorization: `Bearer ${authTokens?.token}` },
  withCredentials: true
});
axiosInstance.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem("tk") || authTokens?.token;

    if (!authTokens?.token) {
      authTokens = getAuthTokens();
      token = authTokens?.token;
    }

    if (authTokens?.token) {
      config.headers.Authorization = `Bearer ${authTokens?.token ?? token}`;

      try {
        const decodedToken: any = jwtDecode(authTokens?.token);
        const isExpired = dayjs.unix(decodedToken.exp).diff(dayjs(), 'seconds') < 30;

        if (isExpired && authTokens?.refreshToken) {
          const postData = { refreshToken: authTokens.refreshToken };
          const response = await axios.post(`${baseURL}/api/openRoute/refreshtoken`, postData, { withCredentials: true });
          localStorage.setItem("Login_info", JSON.stringify(response.data));
          localStorage.setItem("rt", JSON.stringify(response.data.refreshToken));
          sessionStorage.setItem("tk", response.data.token);
          config.headers.Authorization = `Bearer ${response.data.token}`;
        }
      } catch (error) {
        console.error("Failed to refresh token", error);
        localStorage.removeItem("Login_info");
        localStorage.removeItem("rt");
        sessionStorage.removeItem("tk");
        localStorage.removeItem("Login_info_status");
        localStorage.removeItem("cartDataLocal");
        localStorage.removeItem("count");
        localStorage.removeItem("userName");
        sessionStorage.removeItem("userName");
        localStorage.removeItem("orderNumber");
        sessionStorage.removeItem("billing");
        sessionStorage.removeItem("address");
        localStorage.removeItem("phoneNumber");
        window.location.href = "/";
        return Promise.reject(error);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);



export default axiosInstance;
